import { render, staticRenderFns } from "./notification-none.vue?vue&type=template&id=3802ec6f&"
import script from "./notification-none.vue?vue&type=script&lang=js&"
export * from "./notification-none.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports